import Cookies from 'js-cookie';
import axios, { AxiosError } from 'axios';

import { getLang } from './lang';

export type Error = AxiosError<{ code: number; message: string }>;

export const getHeaders = () => ({
  'X-CSRFToken': Cookies.get('csrftoken'),
  lang: getLang(),
});

export const axiosDefault = axios.create({
  timeout: 10000,
  withCredentials: true,
  headers: getHeaders(),
});
